import { HandoverColumn } from '../../../models/handover-column.model';
import { HandoverLog } from '../../../models/handover-log.model';

/**
 * Columns definition for the handover table.
 */
export const HANDOVER_COLUMNS: readonly HandoverColumn[] = [
  { key: 'checkbox', header: '', accessor: (l: HandoverLog) => '' },
  { key: 'activity', header: 'Activity Type', accessor: (l: HandoverLog) => l.activity },
  { key: 'program', header: 'Program', accessor: (l: HandoverLog) => l.programName },
  { key: 'notes', header: 'Notes', accessor: (l: HandoverLog) => l.notes },
  { key: 'dueDate', header: 'Due Date', accessor: (l: HandoverLog) => l.dueDate },
  { key: 'createdBy', header: 'Created by', accessor: (l: HandoverLog) => l.createdByName },
  { key: 'action', header: '', accessor: (l: HandoverLog) => '' },
] as const;
